<template>
  <div class="mt-24" v-if="useColors">
    <div>
      <span class="color-gray">Цвет: </span>
      {{ getSelectedProduct?.color?.value }}
    </div>

    <div class="mt-16">
      <SliderColors />
    </div>
  </div>
</template>

<script>
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { mapActions, mapState } from "pinia";
import SliderColors from "@/pages/product_card/components/Sliders/SliderColors";
import { computed } from "vue";

export default {
  name: "ColorsWrap",
  components: { SliderColors },
  methods: {
    ...mapActions(useProductStore, ["setColor"]),
    setColorProvide(element) {
      document.dispatchEvent(new Event("clear-selected-params"));
      document.dispatchEvent(new Event("hidden-error-no-selected"));

      this.setColor(element.target.value);
    },
  },
  provide() {
    return {
      getColors: computed(() => this.getColors),
      isActiveColor: computed(() => this.isActiveColor),
      setColor: this.setColorProvide,
    };
  },
  computed: {
    ...mapState(useProductStore, [
      "getColors",
      "getSelectedProduct",
      "isActiveColor",
    ]),
    useColors() {
      return Object.keys(this.getColors).length > 0;
    },
  },
};
</script>
